<template>
  <v-dialog
    fullscreen
    hide-overlay
    transition="dialog-bottom-transition"
    v-model="isOpen"
    content-class="map-partner-mobile-booking pPartner"
    :persistent="true"
    no-click-animation
  >
    <template v-if="store">
      <div class="map-card-body">
        <div class="map-card-header">
          <div v-if="step < 3" class="no-service">
            <div class="service-item">
              <img
                src="../../assets/images/checkmark-icon-green.webp"
                alt="Häkchen-Symbol"
              />
              <p>Kostenlose Beratung</p>
            </div>
            <div class="service-item">
              <img
                src="../../assets/images/checkmark-icon-green.webp"
                alt="Häkchen-Symbol"
              />
              <p>Kostenübernahme möglich</p>
            </div>
            <div class="service-item">
              <img
                src="../../assets/images/checkmark-icon-green.webp"
                alt="Häkchen-Symbol"
              />
              <p>Schnelle Versorgung</p>
            </div>
          </div>
          <div v-if="step >= 3 && step < 5" class="step3-header-detail">
            <div
              v-if="step == 3 && selectedBookingOption == 'telephone'"
              class="step3-header-detail-title"
            >
              Ihr Termin wurde für Sie reserviert
            </div>
            <div
              v-if="step == 3 && selectedBookingOption == 'instore'"
              class="step3-header-detail-title"
            >
              Ihr Termin in der Filiale wurde für Sie reserviert
            </div>
            <div v-if="step == 4" class="step3-header-confirm">
              <img
                src="../../assets/images/checkmark-icon-green.webp"
                alt="Häkchen-Symbol"
              />
              <div
                v-if="selectedBookingOption == 'telephone'"
                class="step3-header-confirm-title"
              >
                Ihr Telefontermin wurde erfolgreich gebucht
              </div>
              <div v-else class="step3-header-confirm-title">
                Ihr Termin in der Filiale wurde erfolgreich gebucht
              </div>
              <div
                v-if="selectedBookingOption == 'telephone'"
                class="step3-header-confirm-text"
              >
                Ein Experte des Anbieters wird Sie zum gebuchten Termin unter
                der hinterlegten Telefonnummer anrufen.
              </div>
            </div>
            <div class="step3-header-detail-body">
              <img
                src="../../assets/images/Calendar-icon-black.webp"
                alt="Kalendersymbol"
              />
              <div class="s-h-d-date">{{ bookedDate }}</div>
              <div class="s-h-d-line"></div>
              <div class="s-h-d-time">{{ bookedTime }}</div>
            </div>
          </div>
          <div class="card-header-wrapper">
            <div class="card-header-body">
              <div class="header-body">
                <div class="header-title">
                  <div class="store-name">{{ store.storeName }}</div>
                  <div
                    v-if="step > 1 && selectedBookingOption == 'instore'"
                    class="store-street"
                  >
                    {{ store.address.street }}
                  </div>
                  <div
                    v-if="step > 1 && selectedBookingOption == 'instore'"
                    class="store-zip"
                  >
                    {{ store.address.zip }} {{ store.address.city }}
                  </div>
                  <div v-if="false" class="checkout-star-group">
                    <div class="stars">
                      <div>
                        <span v-for="index in 5" :key="index">
                          <img
                            v-if="index <= Math.floor(store.rating)"
                            src="../../assets/images/rating-star-filled-icon.webp"
                            alt="Gefülltes Sternsymbol"
                          />
                          <img
                            v-else-if="
                              0.5 < index - store.rating &&
                              1 > index - store.rating
                            "
                            src="../../assets/images/rating-star-onethirtd-filled-icon.webp"
                            alt="Ein Drittel gefülltes Sternsymbol"
                          />
                          <img
                            v-else-if="0.5 == index - store.rating"
                            src="../../assets/images/rating-star-halffilled-icon.webp"
                            alt="Halb gefülltes Sternsymbol"
                          />
                          <img
                            v-else-if="
                              0 < index - store.rating &&
                              0.5 > index - store.rating
                            "
                            src="../../assets/images/rating-star-twothirds-filled-icon.webp"
                            alt="Zwei Drittel gefülltes Sternsymbol"
                          />
                          <img
                            v-else
                            src="../../assets/images/rating-star-unfilled-icon.webp"
                            alt="Leeres Sternsymbol"
                          />
                        </span>
                      </div>
                    </div>
                    <span class="item-num">{{ store.rating }}</span>
                  </div>
                </div>
                <div class="header-logo">
                  <img :src="store.logoSrc" />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div v-if="step == 1" class="card-body-wrapper">
          <div class="body-desc">
            <div>Buchen Sie jetzt einen persönlichen Termin</div>
            <div>
              So erhalten Sie mit kompetenter Unterstützung auf dem schnellsten
              Weg Ihre Hilfsmittel
            </div>
          </div>
          <div class="body-action">
            <div class="action-wrapper">
              <v-carousel
                v-model="model"
                height="160"
                hide-delimiter-background
                hide-delimiters
              >
                <v-carousel-item v-if="availableBookingOptions.telephone">
                  <div class="action-item">
                    <img
                      src="../../assets/images/phone-icon.webp"
                      class="right-bottom-icon"
                      alt="Telefonsymbol"
                    />
                    <p class="bottom-item-title">Telefonische Beratung</p>
                    <button @click="goToAvailable('telephone')">
                      Termin buchen
                    </button>
                  </div>
                </v-carousel-item>
                <v-carousel-item v-if="availableBookingOptions.instore">
                  <div class="action-item">
                    <img
                      src="../../assets/images/store-icon.webp"
                      class="right-bottom-icon"
                      alt="Filialsymbol"
                    />
                    <p class="bottom-item-title">Beratung in der Filiale</p>
                    <button @click="goToAvailable('instore')">
                      Termin buchen
                    </button>
                  </div>
                </v-carousel-item>
                <v-carousel-item v-if="availableBookingOptions.video">
                  <div class="action-item">
                    <img
                      src="../../assets/images/videocall-icon.webp"
                      class="right-bottom-icon"
                      alt="Symbol für Videoanruf"
                    />
                    <p class="bottom-item-title">Video-Beratung</p>
                    <button @click="goToAvailable('video')">
                      Termin buchen
                    </button>
                  </div>
                </v-carousel-item>
              </v-carousel>
            </div>
          </div>
          <div class="body-footer">
            <div class="footer-container">
              <div>
                <img
                  src="../../assets/images/info-icon.webp"
                  alt="Info-Symbol"
                />
                <p>Warum sollten Sie einen Termin buchen?</p>
              </div>
              <div>
                Hilfsmittel haben einen Einfluss auf Ihre Gesundheit. Um eine
                optimale Versorgung mit Hilfsmitteln für Ihre Situation
                sicherzustellen, sollten Sie eine kostenlose Beratung mit
                Experten des Anbieters in Anspruch nehmen. In der Beratung
                werden neben Ihren Fragen folgende Punkte geklärt:
              </div>
              <div>
                <ul>
                  <li>
                    Sind die gewählten Hilfsmittel die richtigen für Ihre
                    Situation?
                  </li>
                  <li>
                    Worauf sollten Sie bei der Wahl eines passenden Modells
                    achten?
                  </li>
                  <li>Ist eine Kostenübernahme möglich?</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
        <div v-if="step == 2" class="card-available-wrapper">
          <div class="body-available">
            <div class="date-selection">Datum und Uhrzeit wählen</div>
            <div
              v-if="selectedBookingOption == 'telephone'"
              class="date-sub-selection"
            >
              Telefonische Beratung
            </div>
            <div
              v-else-if="selectedBookingOption == 'instore'"
              class="date-sub-selection"
            >
              Beratung in der Filiale
            </div>
            <div v-else class="date-sub-selection">Video-Beratung</div>
            <div class="date-section" v-if="availabilties.length > 0">
              <v-expansion-panels :accordion="true" v-model="panel">
                <v-expansion-panel
                  class="custom-ex-panel"
                  v-for="(item, i) in availabilties"
                  :key="i"
                  @click="clickedDay(item)"
                >
                  <v-expansion-panel-header>
                    {{ item.showDate }}
                  </v-expansion-panel-header>
                  <v-expansion-panel-content>
                    <v-divider class="divid-1"></v-divider>
                    <template v-if="item.slots.length > 6">
                      <div class="dates-wrapper">
                        <div
                          v-for="(slot, j) in item.slots.slice(0, 6)"
                          :key="j"
                          class="date-item"
                          :name="slot.end"
                          :id="
                            slot.start.substring(0, 2) +
                            ':' +
                            slot.start.substring(2, 4)
                          "
                          @click="
                            timeClick(
                              slot.start.substring(0, 2) +
                                ':' +
                                slot.start.substring(2, 4)
                            )
                          "
                        >
                          {{
                            slot.start.substring(0, 2) +
                            ":" +
                            slot.start.substring(2, 4)
                          }}
                        </div>
                      </div>
                      <div class="locked">
                        <div class="dates-wrapper">
                          <div
                            v-for="(slot, j) in item.slots.slice(6)"
                            :key="j"
                            class="date-item"
                            :name="slot.end"
                            :id="
                              slot.start.substring(0, 2) +
                              ':' +
                              slot.start.substring(2, 4)
                            "
                            @click="
                              timeClick(
                                slot.start.substring(0, 2) +
                                  ':' +
                                  slot.start.substring(2, 4)
                              )
                            "
                          >
                            {{
                              slot.start.substring(0, 2) +
                              ":" +
                              slot.start.substring(2, 4)
                            }}
                          </div>
                        </div>
                      </div>
                      <v-divider class="divid-2"></v-divider>
                      <div class="show-all">
                        <span @click="show(i)">Weitere Uhrzeiten anzeigen</span>
                      </div>
                    </template>
                    <template v-else>
                      <div class="dates-wrapper">
                        <div
                          v-for="(slot, j) in item.slots.slice(0, 6)"
                          :key="j"
                          class="date-item"
                          :name="slot.end"
                          :id="
                            slot.start.substring(0, 2) +
                            ':' +
                            slot.start.substring(2, 4)
                          "
                          @click="
                            timeClick(
                              slot.start.substring(0, 2) +
                                ':' +
                                slot.start.substring(2, 4)
                            )
                          "
                        >
                          {{
                            slot.start.substring(0, 2) +
                            ":" +
                            slot.start.substring(2, 4)
                          }}
                        </div>
                      </div>
                      <div class="dates-space"></div>
                    </template>
                  </v-expansion-panel-content>
                </v-expansion-panel>
              </v-expansion-panels>
            </div>
          </div>
        </div>
        <div v-if="step == 3" class="card-summary-wrapper">
          <div class="book-form">
            <div class="form-body">
              <div class="book-subtitle">
                Bestätigen Sie jetzt Ihren Termin mit Ihren persönlichen
                Angaben.
              </div>
              <div class="book-body">
                <div class="book-body-wrap">
                  <div class="subform-element">
                    <v-text-field
                      v-model="firstName"
                      label="Vorname *"
                      class="custom-form-input"
                      height="46px"
                      :rules="rules.name"
                      outlined
                      dense
                    ></v-text-field>
                  </div>
                  <div class="subform-element">
                    <v-text-field
                      v-model="lastName"
                      label="Nachname *"
                      class="custom-form-input"
                      height="46px"
                      :rules="rules.name"
                      outlined
                      dense
                    ></v-text-field>
                  </div>
                  <div class="subform-element">
                    <v-text-field
                      v-model="email"
                      label="E-Mail *"
                      class="custom-form-input"
                      height="46px"
                      :rules="rules.email"
                      outlined
                      dense
                    ></v-text-field>
                  </div>
                  <div class="subform-element">
                    <v-text-field
                      v-model="phoneNumber"
                      label="Telefonnummer *"
                      class="custom-form-input"
                      height="46px"
                      :rules="rules.telephone"
                      outlined
                      dense
                      type="tel"
                    ></v-text-field>
                  </div>
                  <div class="prescription-radio">
                    Haben Sie bereits ein Rezept für Ihre gewählten Hilfsmittel?
                    *
                    <RadioButtonGroupRect
                      :data="prescriptionRadio"
                      @selectRadio="selectRadio"
                    />
                  </div>
                  <div class="book-msg">
                    <label>Ihre Nachricht an das Sanitätshaus (optional)</label>
                    <v-textarea
                      v-model="message"
                      label=""
                      height="140px"
                      single-line
                      outlined
                      dense
                    ></v-textarea>
                  </div>
                  <div class="book-term">
                    <v-checkbox v-model="checkTerm"></v-checkbox>
                    <p>
                      Ich stimme den
                      <a
                        href="https://www.anni.care/datenschutz/"
                        target="_blank"
                        class="jump-next"
                        >Datenschutzbestimmungen</a
                      >
                      zu und bin mit der Weitergabe meiner Daten an den Anbieter
                      einverstanden.
                    </p>
                  </div>
                  <button
                    v-if="passed"
                    class="g-blue-btn btn-absol w-100 he-43x"
                    @click="submit"
                  >
                    Termin buchen
                  </button>
                  <button v-else class="g-disabled-btn btn-absol w-100 he-43x">
                    Termin buchen
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div v-if="step == 4" class="result-wrapper">
          <div v-if="prescriptionRadio == 'yes'" class="result-header">
            <div class="submit-result">
              <div class="result-icon-1">
                <img
                  src="../../assets/images/Prescription-icon.webp"
                  alt="Rezeptsymbol"
                />
              </div>
              <div class="result-title">
                Sie möchten die Kostenübernahme vorab prüfen lassen?
              </div>
              <div class="result-sub-title">
                Reichen Sie jetzt Ihr Hilfsmittel-Rezept ein, sodass der
                Anbieter das Rezept vor der Beratung prüfen kann.
              </div>
              <button
                class="g-blue-btn btn-absol w-100 he-43x mt-10x"
                @click="goToUpload"
              >
                Rezept einreichen
              </button>
            </div>
          </div>
          <div v-else-if="prescriptionRadio == 'no'" class="result-header">
            <div class="submit-result">
              <div class="result-icon-1">
                <img
                  src="../../assets/images/Prescription-icon.webp"
                  alt="Rezeptsymbol"
                />
              </div>
              <div class="result-title">
                Sie möchten für eine Kostenübernahme noch ein Rezept einholen?
              </div>
              <div class="result-sub-title">
                Sie erhalten ein Schreiben für den behandelnden Arzt,, der bei
                medizinischer Notwendigkeit die richtigen Rezepte für Ihre
                Hilfsmittel ausstellen kann.
              </div>
              <template v-if="!isPDFDownloaded">
                <button
                  class="g-blue-btn btn-absol w-100 he-43x mt-10x spin-p-btn-w"
                  @click="generatePDF"
                  ref="npmodal"
                >
                  <span class="button__text" v-if="!isDownloading"
                    >Rezept einholen</span
                  >
                </button>
              </template>
              <template v-else>
                <button
                  class="g-disabled-btn btn-absol w-100 he-43x mt-10x spin-p-btn-w"
                >
                  <span class="button__text" v-if="!isDownloading"
                    >Schreiben wurde generiert</span
                  >
                </button>
              </template>
            </div>
          </div>
        </div>
        <div v-if="step == 5" class="prescription-wrapper">
          <div class="pre-title">Rezept einreichen</div>
          <div class="pre-sub-title">Wie möchten Sie das Rezept erfassen?</div>
          <div class="pre-card">
            <div class="precard-body">
              <input
                type="file"
                id="mFile"
                capture="camera"
                hidden
                @change="capture"
              />
              <img
                src="../../assets/images/prescription-photo-icon.webp"
                alt="Symbol für ein Rezeptfoto"
              />
              <div>
                <p class="pcard-title">Foto aufnehmen</p>
                <p class="pcard-des">
                  Erstellen Sie jetzt einen Scan Ihres Rezept über Ihre
                  Kamerafunktion.
                </p>
              </div>
            </div>
            <button
              class="g-blue-btn btn-absol w-100 he-43x"
              @click="openCamera()"
            >
              Rezept erfassen
            </button>
          </div>
          <div class="pre-card">
            <div class="precard-body">
              <input
                id="fileUpload"
                type="file"
                accept=".pdf,.png,.jpeg,.heic"
                hidden
                @change="selectedFile"
                multiple="multiple"
              />
              <img
                src="../../assets/images/Prescription-upload-icon.webp"
                alt="Symbol für ein Rezeptfoto"
              />
              <div>
                <p class="pcard-title">Datei hochladen</p>
                <p class="pcard-des">
                  Laden Sie eine Kopie Ihres Rezeptes hoch.*
                </p>
              </div>
            </div>
            <button
              class="g-blue-btn btn-absol w-100 he-43x"
              @click="openFileExplorer()"
            >
              Datei auswählen
            </button>
            <div class="precard-extension">
              *Mögliche Dateiformate: PDF, PNG, JPEG, HEIC
            </div>
          </div>
        </div>
        <div v-if="step == 6" class="prescription-result">
          <div class="p-result-body">
            <div class="p-r-title">Rezept einreichen</div>
            <div class="p-r-list">
              <div class="p-r-item" v-for="(item, index) in files" :key="index">
                <!-- <img class="p-img" :src="item.src" alt=""> -->
                <embed
                  v-if="item.type == 'image/png'"
                  type="image/png"
                  :src="item.src"
                  class="p-img"
                />
                <embed
                  v-else-if="item.type == 'image/jpeg'"
                  type="image/jpeg"
                  :src="item.src"
                  class="p-img"
                />
                <embed
                  v-else-if="item.type == 'image/heic'"
                  :src="item.src"
                  class="p-img"
                />
                <img v-else :src="item.src" class="p-img" />
                <p>{{ item.name }}</p>
                <img
                  class="p-rev"
                  src="../../assets/images/remove icon.webp"
                  alt="Symbol entfernen"
                  @click="remove(index)"
                />
              </div>
            </div>
            <div class="p-r-add">
              <input
                id="fileUpload"
                type="file"
                accept=".pdf,.png,.jpeg,.heic"
                hidden
                @change="selectedFile"
                multiple="multiple"
              />
              <img
                @click="openFileExplorer()"
                src="../../assets/images/add-more-icon.webp"
                alt="Symbol hinzufügen"
              />
              <p @click="openFileExplorer()">weiteres Rezept hinzufügen</p>
            </div>
            <v-divider class="d-v"></v-divider>
            <div class="p-term">
              <v-checkbox v-model="checkPTerm"></v-checkbox>
              <p>
                Ich stimme den
                <a
                  href="https://www.anni.care/datenschutz/"
                  target="_blank"
                  class="jump-next"
                  >Datenschutzbestimmungen</a
                >
                zu und bin mit der Weitergabe meiner Daten an den Anbieter
                einverstanden.
              </p>
            </div>
            <button
              v-if="checkPTerm && files.length != 0"
              class="g-blue-btn btn-absol w-100 he-43x mt-n-20x"
              @click="upload"
            >
              Rezept einreichen
            </button>
            <button
              v-else
              class="g-disabled-btn btn-absol w-100 he-43x mt-n-20x"
            >
              Rezept einreichen
            </button>
          </div>
        </div>
        <div v-if="step == 7" class="prescription-final">
          <div class="p-result-body">
            <img
              src="../../assets/images/Prescription-sent-icon.webp"
              alt="Symbol „Rezept gesendet“."
            />
            <p class="end-text">Ihr Rezept wurde erfolgreich eingereicht.</p>
          </div>
          <div class="btn-wrapper">
            <a href="https://anni.care/" target="_blank">
              <button class="to-home-btn">Zur Startseite</button>
            </a>
          </div>
        </div>
        <div v-if="step == 8" class="prescription-final">
          <div class="p-result-error">
            <p class="error-msg bold center">
              {{ UI_CONSTANTS.requestErrTitle }}
            </p>
            <p class="error-s-msg">{{ UI_CONSTANTS.requestErrMsg }}</p>
            <p class="error-s-msg bold center">
              {{ UI_CONSTANTS.requestNumber }}
            </p>
          </div>
          <div class="btn-wrapper">
            <a href="https://anni.care/" target="_blank">
              <button class="to-home-btn">Zur Startseite</button>
            </a>
          </div>
        </div>
      </div>

      <!-- loading modal -->
      <v-dialog v-model="requesting" content-class="v-custom-pro">
        <v-progress-circular
          :size="100"
          :width="9"
          color="white"
          indeterminate
        ></v-progress-circular>
      </v-dialog>
      <v-snackbar
        v-model="snackbar"
        :top="true"
        :right="true"
        color="#F2A16B"
        :timeout="timeout"
      >
        {{ warnningMsg }}
        <template v-slot:action="{ attrs }">
          <v-btn color="white" text v-bind="attrs" @click="snackbar = false">
            x
          </v-btn>
        </template>
      </v-snackbar>
    </template>
  </v-dialog>
</template>
<script>
import {
  isValidMail,
  isValidTel,
  isValidName,
} from "../../services/ValidationService";
import RadioButtonGroupRect from "../RadioButtons/RadioButtonGroupRect.vue";
import UI_CONSTANTS from "../../../uiConstants";
import {
  getBookingAvailability,
  createNewOrder,
  createNewBook,
  uploadPrescriptions,
  addFileIdsOrder,
  generatePDF,
} from "../../services/MainService";
import convert from "heic-convert";
import pdfLogo from "../../assets/images/png-transparent-pdfcreator-document-file-format-icon-pdf-text-logo-doc.png";
import { mapActions } from "vuex";
export default {
  components: {
    RadioButtonGroupRect,
  },
  props: {
    isOpen: Boolean,
    store: Object,
    data: Object,
    availableBookingOptions: Object,
    storeAvailability: Array,
    storeAvailabilties: Array,
  },
  data() {
    return {
      model: 0,
      step: 1,
      rules: {
        email: [(input) => isValidMail(input) || UI_CONSTANTS.wrongEmail],
        name: [(input) => isValidName(input) || UI_CONSTANTS.wrongName],
        telephone: [
          (input) => isValidTel(input) || UI_CONSTANTS.wrongTelephone,
        ],
        street: [(input) => isValidName(input) || UI_CONSTANTS.wrongStreet],
        city: [(input) => isValidName(input) || UI_CONSTANTS.wrongCity],
        zip: [(input) => isValidName(input) || UI_CONSTANTS.wrongZip],
      },
      panel: 0,
      passed: false,
      prescriptionRadio: "default", //default
      checkTerm: false,
      checkPTerm: false,
      firstName: null,
      lastName: null,
      email: null,
      phoneNumber: null,
      message: null,
      orderID: null,
      requesting: false,
      selectedBookingOption: null,
      availabilties: [],
      bookedDate: null,
      bookedTime: null,
      durationInMinutes: null,
      selectedDate: null,
      selectedSlotStart: null,
      selectedSlotEnd: null,
      files: [],
      UI_CONSTANTS: UI_CONSTANTS,
      snackbar: false,
      uploadedFiles: [],
      timeout: 5000,
      isDownloading: false,
      isPDFDownloaded: false,
      warnningMsg: null,
      streetAndHouseNumber: null,
      postalCode: null,
      city: null,
    };
  },
  methods: {
    ...mapActions(["recordInteraction"]),
    back() {
      let mobileHeaderData;
      if (this.step == 1) {
        this.step = 1;
        this.$emit("closePtRe", false);
        mobileHeaderData = {
          storeType: "pPartner",
          isOpened: false,
        };
      } else if (this.step == 2) {
        this.step = 1;
        this.nextScrollTop0();
        mobileHeaderData = {
          storeType: "pPartner",
          step: 1,
          title: "Termin wählen",
          lastStep: false,
          isOpened: true,
        };
      } else if (this.step == 3) {
        this.step = 2;
        this.nextScrollTop0();
        this.panel = 0;
        this.bookedDate = this.availabilties[0].date;
        mobileHeaderData = {
          storeType: "pPartner",
          step: 2,
          title: "Termin wählen",
          lastStep: false,
          isOpened: true,
        };
      } else if (this.step == 4) {
        this.step = 1;
        this.nextScrollTop0();
        this.$emit("closePtRe", false);
        mobileHeaderData = {
          storeType: "pPartner",
          isOpened: false,
        };
      } else if (this.step == 5) {
        this.step = 4;
        this.nextScrollTop0();
        mobileHeaderData = {
          storeType: "pPartner",
          step: 4,
          title: "Termin gebucht",
          lastStep: true,
          isOpened: true,
        };
      } else if (this.step == 6) {
        this.step = 5;
        this.nextScrollTop0();
        mobileHeaderData = {
          storeType: "pPartner",
          step: 5,
          title: "Rezept einreichen",
          lastStep: false,
          isOpened: true,
        };
      } else if (this.step == 8 || this.step == 7) {
        this.step = 1;
        this.nextScrollTop0();
        this.$emit("closePtRe", false);
        mobileHeaderData = {
          storeType: "pPartner",
          step: 1,
          title: "Termin wählen",
          lastStep: false,
          isOpened: true,
        };
      } else {
        this.step = 1;
        this.nextScrollTop0();
        this.$emit("closePtRe", false);
        mobileHeaderData = {
          storeType: "pPartner",
          isOpened: false,
        };
      }
      this.$root.$emit("mobile-checkout", mobileHeaderData);
    },
    wheeledBack() {
      let mobileHeaderData;
      if (this.step == 2) {
        this.step = 2;
        this.$emit("closePtRe", false);
        mobileHeaderData = {
          storeType: "dPartner",
          isOpened: false,
        };
      } else if (this.step == 3) {
        this.step = 2;
        this.nextScrollTop0();
        this.panel = 0;
        this.bookedDate = this.availabilties[0].date;
        mobileHeaderData = {
          storeType: "dPartner",
          step: 2,
          title: "Liefertermin wählen ",
          lastStep: false,
          isOpened: true,
        };
      } else if (this.step == 4) {
        this.step = 2;
        this.nextScrollTop0();
        this.$emit("closePtRe", false);
        mobileHeaderData = {
          storeType: "dPartner",
          isOpened: false,
        };
      } else if (this.step == 5) {
        this.step = 4;
        this.nextScrollTop0();
        mobileHeaderData = {
          storeType: "dPartner",
          step: 4,
          title: "Termin gebucht",
          lastStep: true,
          isOpened: true,
        };
      } else if (this.step == 6) {
        this.step = 5;
        this.nextScrollTop0();
        mobileHeaderData = {
          storeType: "dPartner",
          step: 5,
          title: "Rezept einreichen",
          lastStep: false,
          isOpened: true,
        };
      } else if (this.step == 8 || this.step == 7) {
        this.step = 1;
        this.nextScrollTop0();
        this.$emit("closePtRe", false);
        mobileHeaderData = {
          storeType: "dPartner",
          step: 1,
          title: "Termin wählen",
          lastStep: false,
          isOpened: true,
        };
      }
      this.$root.$emit("mobile-checkout", mobileHeaderData);
    },
    show(index) {
      let parentNode = document.querySelector(
        ".date-section > div:first-child > div:nth-child(" +
          (index + 1) +
          ") > div:nth-child(2) > div:first-child"
      );
      let hiddenWrapper = parentNode.children[2];
      let divid2 = parentNode.children[3];
      if (hiddenWrapper.classList.contains("unlocked")) {
        hiddenWrapper.classList.remove("unlocked");
        divid2.style.marginTop = "0px";
        parentNode.children[4].children[0].innerHTML =
          "Weitere Uhrzeiten anzeigen";
      } else {
        hiddenWrapper.classList.add("unlocked");
        divid2.style.marginTop = "10px";
        parentNode.children[4].children[0].innerHTML = "Weniger anzeigen";
      }
    },
    async goToAvailable(bookingOption) {
      this.requesting = true;
      let reqData = {};
      reqData.storeID = this.store.storeID;
      reqData.storeSrc = this.store.dataSrc;
      reqData.bookingOption = bookingOption;
      this.selectedBookingOption = bookingOption;
      let result = await getBookingAvailability(reqData);
      this.requesting = false;
      if (result.success) {
        console.log(result);
        const options = { weekday: "long", month: "long", day: "numeric" };
        this.availabilties = result.data.map((item) => {
          let newDate = new Date(item.date);
          newDate.setDate(newDate.getDate());
          item.showDate = new Date(newDate).toLocaleDateString(
            "de-DE",
            options
          );
          return item;
        });
        console.log(this.availabilties);
        this.panel = 0;
        this.bookedDate = this.availabilties[0].date;
        this.selectedDate = this.availabilties[0].date;
        this.step = 2;
        this.nextScrollTop0();
        let mobileHeaderData;
        mobileHeaderData = {
          storeType: "pPartner",
          step: 2,
          title: "Termin wählen",
          lastStep: false,
          isOpened: true,
        };
        this.$root.$emit("mobile-checkout", mobileHeaderData);
        for (var i = 0; i < result.data.length; i++) {
          if (result.data[i].slots.length != 0) {
            let endMins =
              Math.floor(parseInt(result.data[i].slots[0].end) / 100) * 60 +
              (parseInt(result.data[i].slots[0].end) % 100);
            let startMins =
              Math.floor(parseInt(result.data[i].slots[0].start) / 100) * 60 +
              (parseInt(result.data[i].slots[0].start) % 100);
            this.durationInMinutes = endMins - startMins;
            break;
          }
        }
      }
    },
    timeClick(time) {
      this.selectedSlotStart = parseInt(time.replace(":", ""));
      this.selectedSlotEnd = parseInt(
        document.getElementById(time).getAttribute("name")
      );
      // const options = { month: 'long', year: 'numeric', day: 'numeric' };
      const options = { weekday: "long", month: "long", day: "numeric" };
      let newDate = new Date(this.bookedDate);
      newDate.setDate(newDate.getDate());
      this.bookedDate = new Date(newDate).toLocaleDateString("de-DE", options);
      this.bookedTime = time.replace(":", ".") + " Uhr";
      this.step = 3;
      this.nextScrollTop0();
      let mobileHeaderData;
      mobileHeaderData = {
        storeType: "pPartner",
        step: 3,
        title: "Termin bestätigen",
        lastStep: false,
        isOpened: true,
      };
      this.$root.$emit("mobile-checkout", mobileHeaderData);
    },
    clickedDay(dayObj) {
      this.bookedDate = dayObj.date;
      this.selectedDate = dayObj.date;
    },
    goToUpload() {
      this.files = [];
      this.uploadedFiles = [];
      this.step = 5;
      this.nextScrollTop0();
      let mobileHeaderData;
      mobileHeaderData = {
        storeType: "pPartner",
        step: 5,
        title: "Rezept einreichen",
        lastStep: false,
        isOpened: true,
      };
      this.$root.$emit("mobile-checkout", mobileHeaderData);
      this.recordInteraction({
        eventType: "interfaceInteraction",
        eventData: {
          source: "PartnerMeetingBookingMobile",
          type: "button",
          selection: "RezeptEinreichen",
        },
      });
    },
    openCamera() {
      document.getElementById("mFile").click();
      this.recordInteraction({
        eventType: "interfaceInteraction",
        eventData: {
          source: "PartnerMeetingBookingMobile",
          type: "button",
          selection: "RezeptErfassen",
        },
      });
    },
    openFileExplorer() {
      document.getElementById("fileUpload").click();
      this.recordInteraction({
        eventType: "interfaceInteraction",
        eventData: {
          source: "PartnerMeetingBookingMobile",
          type: "button",
          selection: "DateiAuswählen",
        },
      });
    },
    async upload() {
      this.requesting = true;
      const formData = new FormData();
      for (const i of Object.keys(this.uploadedFiles)) {
        formData.append("files", this.uploadedFiles[i]);
      }
      let result = await uploadPrescriptions(formData);
      console.log(result);
      if (result.success) {
        let reqData = {
          orderID: this.orderID,
          fileIDs: result.data.map((f) => f.id),
        };
        let resultAddedIDs = await addFileIdsOrder(reqData);
        this.requesting = false;
        let mobileHeaderData;
        mobileHeaderData = {
          storeType: "pPartner",
          step: 1,
          title: "Rezept eingereicht",
          lastStep: true,
          isOpened: true,
        };
        if (resultAddedIDs.success) {
          this.step = 7;
          mobileHeaderData.step = 7;
        } else {
          this.step = 8;
          mobileHeaderData.step = 8;
        }
        this.nextScrollTop0();
        this.$root.$emit("mobile-checkout", mobileHeaderData);

        this.recordInteraction({
          eventType: "newFileUploaded",
          eventData: {
            typeOfFile: "prescription",
          },
        });
      } else {
        this.requesting = false;
        this.step = 8;
        this.nextScrollTop0();
        let mobileHeaderData;
        mobileHeaderData = {
          storeType: "pPartner",
          step: 8,
          title: "Rezept eingereicht",
          lastStep: true,
          isOpened: true,
        };
        this.$root.$emit("mobile-checkout", mobileHeaderData);
      }
    },
    async capture() {
      let file = document.getElementById("mFile").files[0];
      await this.handleFile(file);
      this.step = 6;
      this.nextScrollTop0();
      let mobileHeaderData;
      mobileHeaderData = {
        storeType: "pPartner",
        step: 6,
        title: "Rezept einreichen",
        lastStep: false,
        isOpened: true,
      };
      this.$root.$emit("mobile-checkout", mobileHeaderData);
    },
    async selectedFile() {
      for (
        var i = 0;
        i < document.getElementById("fileUpload").files.length;
        i++
      ) {
        await this.handleFile(document.getElementById("fileUpload").files[i]);
      }
      this.step = 6;
      this.nextScrollTop0();
      let mobileHeaderData;
      mobileHeaderData = {
        storeType: "pPartner",
        step: 6,
        title: "Rezept einreichen",
        lastStep: false,
        isOpened: true,
      };
      this.$root.$emit("mobile-checkout", mobileHeaderData);
    },
    async handleFile(file) {
      if (file.size <= 10485760) {
        // default file size limit is 10MB.
        let filename = file.name;
        let extensions = ["image/png", "image/jpeg", "image/jpg"];
        if (!this.isProperExt(file)) {
          document.getElementById("fileUpload").value = null;
          this.warnningMsg = UI_CONSTANTS.fileExtErrorMsg;
          this.snackbar = true;
          return;
        }
        var reader = new FileReader();
        var fileData;
        var promise;
        var tempFile;
        this.uploadedFiles.push(file);
        const self = this;
        if (file && extensions.includes(file.type)) {
          reader.readAsText(file, "UTF-8");
          tempFile = {
            name: file.name,
            type: file.type,
            size: file.size,
            src: URL.createObjectURL(file),
          };
          this.files.push(tempFile);
        } else if (file && file.type == "application/pdf") {
          tempFile = {
            name: file.name,
            type: "application/pdf",
            size: file.size,
            src: "",
          };
          tempFile.src = pdfLogo;
          this.files.push(tempFile);
        } else if (filename.split(".").reverse()[0] == "heic") {
          tempFile = {
            name: file.name,
            type: "image/heic",
            size: file.size,
            src: "",
          };
          fileData = new Blob([file]);
          promise = new Promise(this.getBuffer(fileData));
          promise
            .then(async function (data) {
              // Here you can pass the bytes to another function.
              const outputBuffer = await convert({
                buffer: data, // the HEIC file buffer
                format: "PNG", // output format
              });
              const b64 = new Buffer(outputBuffer).toString("base64");
              const mimeType = "image/png";
              tempFile.src = "data:" + mimeType + ";base64," + b64;
              self.files.push(tempFile);
            })
            .catch(function (err) {
              console.log("Error: ", err);
            });
        }
      } else {
        document.getElementById("fileUpload").value = null;
        this.warnningMsg = UI_CONSTANTS.fileSizeOverMsg;
        this.snackbar = true;
      }
    },
    // check if file's extension is png,jpeg,pdf or heic
    isProperExt(file) {
      let extensions = [
        "image/png",
        "image/jpeg",
        "image/jpg",
        "application/pdf",
      ];
      if (file && extensions.includes(file.type)) {
        return true;
      } else if (file.name.split(".").reverse()[0] == "heic") {
        return true;
      } else {
        return false;
      }
    },
    // returns Buffer Array from file by using FileReader
    getBuffer(fileData) {
      return function (resolve) {
        var reader = new FileReader();
        reader.readAsArrayBuffer(fileData);
        reader.onload = function () {
          var arrayBuffer = reader.result;
          var bytes = new Uint8Array(arrayBuffer);
          resolve(bytes);
        };
      };
    },
    remove(index) {
      document.getElementById("fileUpload").value = null;
      this.files = this.files.filter((item, i) => index != i);
      this.uploadedFiles = this.uploadedFiles.filter((item, i) => index != i);
    },
    async generatePDF() {
      if (!this.isDownloading) {
        this.isDownloading = true;
        this.$refs.npmodal.classList.add("p-button--loading");
        let products = this.data.products.map((item) => {
          return item.id;
        });
        let response = await generatePDF(products.join(","));
        if (response) {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement("a");
          link.href = url;
          const fileName = response.headers["content-disposition"].substring(
            21,
            52
          );
          link.setAttribute("download", fileName);
          document.body.appendChild(link);
          link.click();
          link.remove();
          this.isPDFDownloaded = true;
        }
        this.isDownloading = false;
        this.$refs.npmodal.classList.remove("p-button--loading");
      }
    },
    selectRadio(e) {
      this.prescriptionRadio = e;
    },
    nextScrollTop0() {
      document.querySelector(".map-card-body").scrollTop = "0px";
    },
    async submit() {
      this.requesting = true;
      let data = {
        customerDetails: {
          firstname: "",
          lastname: "",
          telephone: "",
          mail: "",
          city: "",
          street: "",
          zip: "",
        },
        orderDetails: {
          products: [],
          insurance: "",
          message: "",
          prescriptionPresent: true,
          selectedProvider: {
            dataSrc: "",
            storeID: "",
          },
        },
      };
      data.customerDetails.firstname = this.firstName;
      data.customerDetails.lastname = this.lastName;
      data.customerDetails.mail = this.email;
      data.customerDetails.phone1 = this.phoneNumber;
      data.orderDetails.products = this.data.products.map((item) => item.id);
      data.customerDetails.city = this.data.address.userSuggestion;
      data.orderDetails.insurance =
        JSON.stringify(this.data.insurance) == "{}"
          ? undefined
          : this.data.insurance.insuranceID.toString();
      data.orderDetails.message = this.message ? this.message : "";
      data.orderDetails.prescriptionPresent =
        this.prescriptionRadio == "yes" ? true : false;
      data.orderDetails.selectedProvider.dataSrc = this.store.dataSrc;
      data.orderDetails.selectedProvider.storeID =
        this.store.storeID.toString();
      data.orderDetails.selectedProvider.chainID =
        this.store.chainID.toString();
      let result = await createNewOrder(data);
      if (result.success) {
        this.orderID = result.data.orderID;
        let reqData = {
          orderID: this.orderID,
          selectedProvider: {
            storeID: this.store.storeID.toString(),
            chainID: this.store.chainID.toString(),
          },
          bookingOption: this.selectedBookingOption,
          date: this.selectedDate,
          slot: {
            start: this.selectedSlotStart,
            end: this.selectedSlotEnd,
          },
        };
        await createNewBook(reqData);
        this.step = 4;
        this.nextScrollTop0();
        let mobileHeaderData;
        mobileHeaderData = {
          storeType: "pPartner",
          step: 4,
          title: "Termin gebucht",
          lastStep: true,
          isOpened: true,
        };
        this.$root.$emit("mobile-checkout", mobileHeaderData);
        this.requesting = false;
        this.recordInteraction({
          eventType: "newInquiryPlaced",
          eventData: {
            listedPartner: true,
            typeOfInquiry: this.selectedBookingOption,
          },
        });
      }
    },
  },
  mounted() {
    this.$root.$on("mobile-checkout-back", async (data) => {
      if (data.storeType == "pPartner") {
        this.back();
      }
      if (data.storeType == "dPartner") {
        this.wheeledBack();
      }
    });
  },
  watch: {
    firstName(value) {
      if (
        isValidName(value) &&
        isValidName(this.lastName) &&
        isValidMail(this.email) &&
        isValidTel(this.phoneNumber) &&
        this.checkTerm &&
        this.prescriptionRadio != "default"
      ) {
        this.passed = true;
      } else {
        this.passed = false;
      }
    },
    lastName(value) {
      if (
        isValidName(this.firstName) &&
        isValidName(value) &&
        isValidMail(this.email) &&
        isValidTel(this.phoneNumber) &&
        this.checkTerm &&
        this.prescriptionRadio != "default"
      ) {
        this.passed = true;
      } else {
        this.passed = false;
      }
    },
    email(value) {
      if (
        isValidName(this.firstName) &&
        isValidName(this.lastName) &&
        isValidMail(value) &&
        isValidTel(this.phoneNumber) &&
        this.checkTerm &&
        this.prescriptionRadio != "default"
      ) {
        this.passed = true;
      } else {
        this.passed = false;
      }
    },
    phoneNumber(value) {
      if (
        isValidName(this.firstName) &&
        isValidName(this.lastName) &&
        isValidMail(this.email) &&
        isValidTel(value) &&
        this.checkTerm &&
        this.prescriptionRadio != "default"
      ) {
        this.passed = true;
      } else {
        this.passed = false;
      }
    },
    checkTerm(value) {
      if (
        isValidName(this.firstName) &&
        isValidName(this.lastName) &&
        isValidMail(this.email) &&
        isValidTel(this.phoneNumber) &&
        value &&
        this.prescriptionRadio != "default"
      ) {
        this.passed = true;
      } else {
        this.passed = false;
      }
    },
    streetAndHouseNumber(value) {
      if (
        isValidName(this.firstName) &&
        isValidName(this.lastName) &&
        isValidMail(this.email) &&
        isValidTel(this.phoneNumber) &&
        this.checkTerm &&
        isValidName(value) &&
        isValidName(this.postalCode) &&
        isValidName(this.city) &&
        this.prescriptionRadio != "default"
      ) {
        this.passed = true;
      } else {
        this.passed = false;
      }
    },
    postalCode(value) {
      if (
        isValidName(this.firstName) &&
        isValidName(this.lastName) &&
        isValidMail(this.email) &&
        isValidTel(this.phoneNumber) &&
        this.checkTerm &&
        isValidName(this.streetAndHouseNumber) &&
        isValidName(value) &&
        isValidName(this.city) &&
        this.prescriptionRadio != "default"
      ) {
        this.passed = true;
      } else {
        this.passed = false;
      }
    },
    city(value) {
      if (
        isValidName(this.firstName) &&
        isValidName(this.lastName) &&
        isValidMail(this.email) &&
        isValidTel(this.phoneNumber) &&
        this.checkTerm &&
        isValidName(this.streetAndHouseNumber) &&
        isValidName(this.postalCode) &&
        isValidName(value) &&
        this.prescriptionRadio != "default"
      ) {
        this.passed = true;
      } else {
        this.passed = false;
      }
    },
    prescriptionRadio(value) {
      if (
        isValidName(this.firstName) &&
        isValidName(this.lastName) &&
        isValidMail(this.email) &&
        isValidTel(this.phoneNumber) &&
        this.checkTerm &&
        value != "default"
      ) {
        this.passed = true;
      } else {
        this.passed = false;
      }
    },
  },
};
</script>
